import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-agences-coffee',
  templateUrl: './agences-coffee.component.html',
  styleUrls: ['./agences-coffee.component.scss']
})
export class AgencesCoffeeComponent implements OnInit {

  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  p: Number = 1;
  closeResult = '';
  search_name1:any;
  public search: string  = ''
  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any

  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  lengthSociete=10;
  totalSociete : any
  public AgenciesTunis: any
  

  constructor(private agenciesService: AgenciesService,
    private primengConfig: PrimeNGConfig,
    private searchService: SearchService
  
    ) { }

  ngOnInit() {
    this. getListeCoffee() ;


  }

  getListeCoffee() {
    this.agenciesService.getList().subscribe((data: any) => {
      this.AgenciesTunis = data;
      console.log("liste des banques", this.AgenciesTunis);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.AgenciesTunis.filter((agencie: any) => {
        return agencie.categorie === 'coffee'; 
        this.performSearch();// Filtre uniquement les promoteurs ayant la région "Banque"
      });
        console.log('thissssssssssssssssssssssssssssssssss',this.agencies)
    });
  }
  
  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }


  public changePage(){
    this.lengthSociete=this.lengthSociete+10;
  }

performSearch() {
  this.AgenciesTunis = this.searchService.search(this.AgenciesTunis, this.search);
}
deleteAgencies(agencie,i) {
  Swal.fire({
    title: `Êtes-vous sûr(e) de supprimer ${agencie.name} ?`,
    text: "Vous ne pourrez pas revenir en arrière !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimez-le."
  }).then((result) => {
    if (result.isConfirmed) {
      this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {
        console.log(this.dataSource.data);
        // this.AgenciesTunis.splice(i,1)

        // If you want to show a success message after the deletion, use another Swal.fire here
        Swal.fire({
          title: "Supprimé!",
          text: "Votre agence a été supprimée.",
          icon: "success"
        });
        // Fetch the updated data after deletion
       
      }); setTimeout(() => {
          this.getListeCoffee();
        }, 500);
      
    }
  });
}
}